import { render, staticRenderFns } from "./Alex2Dialog.vue?vue&type=template&id=1e216d9f&scoped=true"
import script from "./Alex2Dialog.vue?vue&type=script&lang=js"
export * from "./Alex2Dialog.vue?vue&type=script&lang=js"
import style0 from "./Alex2Dialog.vue?vue&type=style&index=0&id=1e216d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e216d9f",
  null
  
)

export default component.exports